export default "__VITE_ASSET__DUgwTf1l__"